import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import Workspace from '../../actions/workspace'

export const WorkspacePropType = PropTypes.shape({
    accountOrn: PropTypes.oneOfType([PropTypes.string, null]),
    isAccount: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    orn: PropTypes.string.isRequired,
})

export default function withWorkspace(ChildComponent) {

    class WithWorkspaceWrapper extends Component {
        static propTypes = {
            dispatch: PropTypes.func.isRequired,
            workspace: WorkspacePropType.isRequired
        }

        constructor(props) {
            super(props)

            this.setWorkspace = this.setWorkspace.bind(this)
        }

        setWorkspace(workspace) {
            this.props.dispatch(Workspace.update(workspace))
        }

        render() {
            const childProps = {
                setWorkspace: this.setWorkspace,
                ...this.props
            }

            return (
                <ChildComponent {...childProps} />
            )
        }
    }

    return connect(mapStateToProps)(WithWorkspaceWrapper)
}

const mapStateToProps = (state) => {
    const { workspace } = state

    return {
        workspace
    }
}



// WEBPACK FOOTER //
// src/containers/high-order-components/with-workspace.js